import React from "react";

const SectionHeader = ({ title, subTitle }) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
        <p className="text-sm text-gray-500 ">{subTitle}</p>
      </div>
    </div>
  );
};

export default SectionHeader;
